module.exports = __webpack_public_path__ + "static/media/note.fa352300.svg";